import EmblaCarousel, { EmblaCarouselType } from 'embla-carousel';
import Fade from 'embla-carousel-fade';
import { setupTweenScale } from './PhotobookSlider/EmblaCarouselTweenScale';

const sliders = document.querySelectorAll<HTMLElement>('.c-photobook-slider');
const PhotobookSlider = {
  init() {
    if (sliders.length) {
      sliders.forEach((sliderEl) => {
        const viewportNode = sliderEl.querySelector<HTMLElement>('.embla__viewport');
        const prevButtonNode = sliderEl.querySelector('.c-photobook-slider__prev');
        const nextButtonNode = sliderEl.querySelector('.c-photobook-slider__next');
        const dotsNode = sliderEl.querySelector<HTMLElement>('.c-photobook-slider__pager');
        if (viewportNode) {
          const emblaApi = EmblaCarousel(viewportNode, { loop: true });
          setupTweenScale(emblaApi);
          if (prevButtonNode) {
            prevButtonNode.addEventListener('click', () => emblaApi.scrollPrev(), false);
          }
          if (nextButtonNode) {
            nextButtonNode.addEventListener('click', () => emblaApi.scrollNext(), false);
          }
          if (dotsNode) {
            addDotButtons(emblaApi, dotsNode);
          }
          const captionSlider = document.querySelector<HTMLElement>(`#${sliderEl.getAttribute('data-caption-slider')}`);
          if (captionSlider) {
            const captEmblaApi = setCationSlider(captionSlider);
            if (captEmblaApi != null) {
              emblaApi.on('reInit', () => {
                const selected = emblaApi.selectedScrollSnap();
                captEmblaApi.scrollTo(selected);
              });
              emblaApi.on('select', () => {
                const selected = emblaApi.selectedScrollSnap();
                captEmblaApi.scrollTo(selected);
              });
            }
          }
        }
      });
    }
  },
};

const addDotButtons = (emblaApi: EmblaCarouselType, dotsNode: HTMLElement) => {
  let dotNodes: HTMLElement[] = [];
  const addDotBtns = () => {
    dotsNode.innerHTML = emblaApi
      .scrollSnapList()
      .map(() => '<span class="_bullet"></span>')
      .join('');
    dotNodes = Array.from(dotsNode.querySelectorAll('._bullet'));
  };

  const toggleDotBtnsActive = () => {
    const previous = emblaApi.previousScrollSnap();
    const selected = emblaApi.selectedScrollSnap();
    dotNodes[previous].classList.remove('is-active');
    dotNodes[selected].classList.add('is-active');
  };

  addDotBtns();
  toggleDotBtnsActive();
  emblaApi.on('reInit', addDotBtns).on('reInit', toggleDotBtnsActive).on('select', toggleDotBtnsActive);
};

const setCationSlider = (wrapNode: HTMLElement): EmblaCarouselType | null => {
  const viewportNode = wrapNode.querySelector<HTMLElement>('.embla__viewport');
  if (viewportNode) {
    const emblaApi: EmblaCarouselType = EmblaCarousel(viewportNode, { containScroll: false }, [Fade()]);
    return emblaApi;
  }
  return null;
};

export { PhotobookSlider };
